export const getCancelledWord = (input = '') => {
	if (input === '') {
		return '';
	}
	const isHsbcProvider = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP;

	if (isHsbcProvider) {
		// Regular expression to match 'canceled' or 'canceling' with case insensitivity
		const cancelRegex = /\bcanceled\b|\bcanceling\b/gi;

		// Replace 'canceled' with 'cancelled' and 'canceling' with 'cancelling', preserving the case
		input = input.replaceAll(cancelRegex, match => {
			// If the match is fully in uppercase
			if (match === match.toUpperCase()) {
				return match === 'CANCELED' ? 'CANCELLED' : 'CANCELLING';
			}
			// If the match is lowercase, replace it with 'cancelled' or 'cancelling' in lowercase
			if (match === match.toLowerCase()) {
				return match === 'canceled' ? 'cancelled' : 'cancelling';
			}
			// If the match starts with an uppercase letter, replace with 'Cancelled' or 'Cancelling'
			return match === 'Canceled' ? 'Cancelled' : 'Cancelling';
		});
	}

	return input;
};
